import Spinner from "../../components/_common/Spinner";

export interface InputProps {
    data: any,
    isloading: Boolean; 
  }
  
  const Storage = ({data,isloading}:InputProps) =>{
    return(
        <div className="tab-content-padding">
        {  isloading === false  && (
        <div>
            <div className="row mb-2">
                <div style={{display:'flex',justifyContent:'center',marginTop:'15px'}}>
                <p dir="rtl" style={{fontSize:'16px'}}>(
                    <span className="storageCommodityCount">  تعداد کالا  </span>|
                    <span className="storageCommodityPrice">  ارزش کالا به تومان   </span>)</p>
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    درحال انقضا     
                </div>
                <div className="col-md-2 storageCommodityCount">
                    {data[0].ExpiringItemCount}
                </div>
                <div className="col-md-2 storageCommodityPrice">
                    {data[0].ExpiringItemPrice}
                </div>
                <div className="col-md-2">
                    منقضی شده
                </div>
                <div className="col-md-2 storageCommodityCount">
                    {data[0].ExpiredItemCount}
                </div>
                <div className="col-md-2 storageCommodityPrice">
                     {data[0].ExpiredItemPrice}
                </div>

            </div>
            <div className="row pt-15">
                <div className="col-md-2">
                    سررسید خرید     
                </div>
                <div className="col-md-2 storageCommodityCount">
                    {data[0].DueDateProductCount}
                </div>
                <div className="col-md-2 storageCommodityPrice">
                    {data[0].DueDateProductPrice}
                </div>
                <div className="col-md-2">
                    ورود/خروج
                </div>
                <div className="col-md-2 storageCommodityCount">
                    {data[0].ImportStorageCount} | {data[0].ExportStorageCount}
                </div>
                <div className="col-md-2 storageCommodityPrice">
                {data[0].ImportStoragePrice} |  {data[0].ExportStoragePrice}
                </div>

            </div>
        </div>

)
}
{
  isloading === true  && (
  <Spinner />
)
}
</div>
    )

}

export default Storage;